module.exports = __webpack_public_path__ + "img/whats-ss-img1.5cc2546f.png";